import { makeStyles } from '@material-ui/core/styles';
import { NAV_RAIL_FULL_WIDTH, NAV_RAIL_ICON_WIDTH } from './nav-rail-width';

const visuallyHidden = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0
};

export default makeStyles((theme) => {
  const iconRail = `@media (min-width: ${theme.screens.tablet}px) and (max-width: ${theme.screens.standard_desktop - 1}px)`;
  const column = {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(3.5, 2.5, 3),
    overflowY: 'auto',
    minHeight: 0
  };
  // A white active item would vanish on the white canvas, so it takes the beige the hover uses.
  const activeBackground = theme.colorPalette.beige_50;
  return {
    rail: {
      ...column,
      flex: `0 0 ${NAV_RAIL_FULL_WIDTH}px`,
      width: NAV_RAIL_FULL_WIDTH,
      borderRight: `1px solid ${theme.colorPalette.beige_60}`,
      [`@media (max-width: ${theme.screens.tablet - 1}px)`]: { display: 'none' },
      [iconRail]: {
        flexBasis: NAV_RAIL_ICON_WIDTH,
        width: NAV_RAIL_ICON_WIDTH,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        '& $groupLabel, & $user': { display: 'none' },
        '& $label': visuallyHidden,
        '& $item': { justifyContent: 'center', flexDirection: 'column', gap: theme.spacing(0.5), minHeight: 56 },
        '& $active': { boxShadow: `inset 0 -3px 0 ${theme.palette.secondary.main}` },
        '& $tag': { fontSize: 8.5, padding: theme.spacing(0, 0.75) }
      },
      '@media print': { display: 'none' }
    },
    drawer: {
      [`@media (min-width: ${theme.screens.tablet}px)`]: { display: 'none' }
    },
    drawerPaper: {
      width: NAV_RAIL_FULL_WIDTH,
      backgroundColor: theme.colors.page__background_primary
    },
    drawerNav: { ...column, flex: '1 1 auto' },
    group: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5)
    },
    groupLabel: {
      margin: theme.spacing(3.5, 2.5, 1.5),
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.09em',
      textTransform: 'uppercase',
      color: theme.colorPalette.beige_90
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2.5),
      minHeight: 40,
      padding: theme.spacing(2, 2.5),
      borderRadius: theme.sizes.innerCorners,
      color: theme.colors.text_primary,
      fontSize: 14,
      textDecoration: 'none',
      position: 'relative',
      '&:hover': { backgroundColor: theme.colorPalette.beige_50 }
    },
    active: {
      backgroundColor: activeBackground,
      fontWeight: 700,
      boxShadow: `inset 3px 0 0 ${theme.palette.secondary.main}`,
      '&:hover': { backgroundColor: activeBackground }
    },
    icon: { fontSize: 20, flex: 'none', color: theme.colors.action_icon },
    label: { minWidth: 0 },
    tag: { marginLeft: 'auto' },
    // Holds the nav illustration; pushes the user block to the bottom.
    illustrationSlot: { marginTop: 'auto' },
    user: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(3.5, 2.5, 1),
      borderTop: `1px solid ${theme.colorPalette.beige_60}`,
      fontSize: 12,
      color: theme.colorPalette.beige_90
    },
    userName: { fontSize: 12.5, fontWeight: 600, color: theme.colors.text_primary },
    userRole: { overflowWrap: 'anywhere' }
  };
});
